import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@pitchero/react-ui';
import ProductCard from './product-card';
import PlaceholderCard from './placeholder-card';

const ProductList = ({ isLoading, products }) => {
  if (isLoading) {
    return (
      <Grid preset="productGrid">
        <PlaceholderCard />
        <PlaceholderCard />
        <PlaceholderCard />
        <PlaceholderCard />
      </Grid>
    );
  }

  if (!products.length) {
    return null;
  }

  return (
    <div className="product-list">
      <Grid preset="productGrid">
        {products.map((product) => (
          <ProductCard key={product.id} {...product} />
        ))}
      </Grid>
    </div>
  );
};

ProductList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default ProductList;
